import { Injectable, Injector } from '@angular/core';
import { BaseState } from "src/app/common/base/base.state";
import { Action, State, StateContext } from "@ngxs/store";
import { MissingTrainingRefresh } from "./procedure-missing-training.action";
import { ProcedureReportService } from "../../services/procedure-report.service";
import { ProcedureReport } from "../../models/procedure-report.model";

export class MissingTrainingStateModel {
  data: ProcedureReport[] = [];
  // An empty training result is valid, so readiness must be tracked separately from item count.
  loaded: boolean = false;
}

@State<MissingTrainingStateModel>({
  name: "MissingTraining",
  defaults: {
    data: [],
    loaded: false,
  }
})
@Injectable()
export class MissingTrainingState extends BaseState {
  constructor(
    protected override injector: Injector, private service: ProcedureReportService
  ) {
    super(injector);
  }

  @Action(MissingTrainingRefresh)
  refresh({ patchState }: StateContext<MissingTrainingStateModel>, { id }: MissingTrainingRefresh) {
    patchState({ loaded: false });
    if (id) {
      this.service.readByUserID(id).subscribe(data => {
        const mt = data.filter(d => d.active && d.revision != d.creditedRevision);
        patchState({ data: mt, loaded: true });
      },
        error => console.error(error)
      );
    }
    else patchState({ data: [], loaded: true });
  }

}
